import { get } from 'lodash/fp';
import axios, { CancelToken } from 'axios';

const withCancellation = (instance) => {
  const cancelTokens = {};

  const genKey = requestConfig => JSON.stringify({
    url: requestConfig.url,
    value: requestConfig.cancellationKey,
  });
  const configureCancellation = (requestConfig) => {
    const key = genKey(requestConfig);

    if (get(key)(cancelTokens)) {
      cancelTokens[key].cancel();
    }
    cancelTokens[key] = CancelToken.source();

    return {
      ...requestConfig,
      cancelToken: cancelTokens[key].token,
    };
  };

  const cleanUpCancellation = (response) => {
    if (response.config.cancellationKey) {
      const key = genKey(response.config);

      delete cancelTokens[key];
    }
  };

  instance.interceptors.request.use((requestConfig) => {
    const modifiedConfig = ({
      ...requestConfig,
      params: {
        ...requestConfig.params,
      },
    });

    return requestConfig.cancellationKey
      ? configureCancellation(modifiedConfig)
      : modifiedConfig;
  });

  instance.interceptors.response.use(
    (res) => {
      cleanUpCancellation(res);
      return Promise.resolve(res);
    },
    (err) => {
      if (!axios.isCancel(err) && err.response) {
        cleanUpCancellation(err.response);
      }
      return Promise.reject(err);
    },
  );

  return instance;
};
export default withCancellation;
